module.exports = __webpack_public_path__ + "static/floorplan7-7fb9bd4c17c7a9bb55764c706e066d3f.png";